import { render } from "./ProductModelHeader.vue?vue&type=template&id=57ec4694&scoped=true"
import script from "./ProductModelHeader.vue?vue&type=script&lang=js"
export * from "./ProductModelHeader.vue?vue&type=script&lang=js"

import "./ProductModelHeader.vue?vue&type=style&index=0&id=57ec4694&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57ec4694"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn});
